import {reportError} from "@finance/shared/observability";
import {initializeObservability} from "@/services/observability";
import {captureLinkHandoff} from "@/services/link_handoff";
import {captureUrlSecrets} from "@/services/url_secrets";

// A plugin link's one-time code, a reset token, and a pending sign-in leave the address bar before anything records the URL.
captureLinkHandoff();
captureUrlSecrets();
initializeObservability();
// Start monitoring before application modules, router, and native bridges load.
void import("./main").catch((error: unknown) => reportError(error, "frontend.startup"));
